











import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({})
export default class ErrorWrappedAnything extends Vue {
  @Prop(String) error: string;

  hasErrors = false;

  @Watch('error')
  divClasses() {
    
    this.hasErrors = !!this.error;
    
  }
}
